import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import ConsultationModal from './components/ConsultationModal.js';
import HomePage from './pages/HomePage.js';
import LinkedInRecruiting from './pages/LinkedInRecruiting.js';
import InstagramRecruiting from './pages/InstagramRecruiting.js';
import TikTokRecruiting from './pages/TikTokRecruiting.js';
import SocialMediaStrategie from './pages/SocialMediaStrategie.js';
import ITTech from './pages/ITTech.js';
import LogistikHandel from './pages/LogistikHandel.js';
import Gastronomie from './pages/Gastronomie.js';
import Startups from './pages/Startups.js';
import Impressum from './pages/Impressum.js';
import AGB from './pages/AGB.js';
import Datenschutz from './pages/Datenschutz.js';
import Leistungen from './pages/Leistungen.js';
import Branchen from './pages/Branchen.js';
import Blog from './pages/Blog.js';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leistungen/linkedin-recruiting" element={<LinkedInRecruiting />} />
          <Route path="/leistungen/instagram-recruiting" element={<InstagramRecruiting />} />
          <Route path="/leistungen/tiktok-recruiting" element={<TikTokRecruiting />} />
          <Route path="/leistungen/social-media-strategie" element={<SocialMediaStrategie />} />
          <Route path="/branchen" element={<Branchen />} />
          <Route path="/branchen/it-tech" element={<ITTech />} />
          <Route path="/branchen/logistik-handel" element={<LogistikHandel />} />
          <Route path="/branchen/gastronomie" element={<Gastronomie />} />
          <Route path="/branchen/startups" element={<Startups />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
        <Footer />
        <ConsultationModal />
      </div>
    </Router>
  );
}

export default App;
